import React, {useState, useEffect} from 'react';
import style from './PreviewSite.module.scss';
import {useSelector} from 'react-redux';
import iphone from './../../assets/images/ihpneXFullWidth.png';
import desktop from './../../assets/images/desktop-preview.png';
import CopyLinkCard from '../CopyLinkCard/CopyLinkCard';
import {useTranslation} from "react-i18next";
import {envConfig} from './../../API/enviromentVariables';
import {selectMediakitUser} from './../../features/stores/mediakitUser.slice';
import {store} from './../../app/store';
import {setShouldSave} from './../../features/stores/changeData.slice';
import UserPublicProfile from './../../pages/UserPublicProfile/UserPublicProfile';
import {previewStyles} from '../../constants/theme';

type PreviewSiteProps = {
  showLink?:boolean;
}

const PreviewSite = ({showLink=true}:PreviewSiteProps) => {
  const {t} = useTranslation();
  const mediakitUser = useSelector(selectMediakitUser);
  const selectChangeData = (state: any) => state.changeData.changeData;
  const [selected, setSelected] = useState<'Mobile' | 'Desktop'>('Mobile');
  const url = envConfig().copyLinkUrl;
  const dataChange = useSelector(selectChangeData);

  const handleSave = () => {
    if (dataChange) {
      store.dispatch(setShouldSave(true));
    }
  };

  return mediakitUser?.id ? <>
    <div className={style.main}>
      {showLink && <CopyLinkCard />}
      <div className={style.tabs}>
        <button className={selected === 'Mobile'? style.tabs__selected : ''} onClick={() => setSelected('Mobile')}>{t('mobile')}</button>
        <button className={selected === 'Desktop'? style.tabs__selected : ''} onClick={() => setSelected('Desktop')}>{t('desktop')}</button>
      </div>
    </div>

    {selected === 'Mobile' &&
    <div className={style.mobile_phone}>
      <img className={style.mobile_phone__phone} src={iphone}></img>
      <div className={style.mobile_phone__content}>
        <UserPublicProfile mediakitUser={mediakitUser} themeProp={{}} selectedStyle='mobile-preview' />
      </div>
    </div>}
    {selected === 'Desktop' &&
    <div className={style.mobile_phone__content_desktop}>
        <div className={style.desktop}>
            <img className={style.desktop_img} src={desktop}/>
            <div className={style.white_bg}></div>
            <div className={style.desktop_div}>
                <UserPublicProfile mediakitUser={mediakitUser} themeProp={{}} selectedStyle={previewStyles.DESKTOP_PREVIEW}/>
            </div>
            <div className={style.black_part}></div>
        </div>
    </div>}
  </> : null;
};

export default PreviewSite;
